import classNames from 'classnames'
import React from 'react'

const DefaultAvatar: React.FC<{ className?: string }> = ({ className }) => (
	<svg xmlns="http://www.w3.org/2000/svg" className={classNames(className)} fill="none" viewBox="0 0 51 51">
		<g clipPath="url(#clip0_1103_23847)">
			<path
				fill="url(#paint0_linear_1103_23847)"
				d="M25.456 50.365c13.808 0 25-11.193 25-25s-11.192-25-25-25c-13.807 0-25 11.193-25 25s11.193 25 25 25z"
				opacity="0.5"
			/>
			<path
				fill="#F5F5F5"
				d="M25.456 50.365c13.808 0 25-11.193 25-25s-11.192-25-25-25c-13.807 0-25 11.193-25 25s11.193 25 25 25z"
			/>
			<path
				fill="#030A7E"
				d="M25.46 50.241c5.308.008 10.502-1.485 14.932-4.294-1-5.256-4.81-5.556-4.81-5.556H14.574s-3.594.284-4.717 5.12c4.568 3.087 10.019 4.74 15.604 4.73z"
			/>
			<path
				fill="#333"
				d="M25.268 36.502c6.524 0 11.813-5.289 11.813-11.812 0-6.524-5.289-11.813-11.813-11.813-6.524 0-11.812 5.289-11.812 11.813 0 6.523 5.288 11.812 11.812 11.812z"
			/>
			<path
				fill="#000"
				d="M21.456 34.528h7.569v6.056a3.785 3.785 0 01-3.783 3.784 3.784 3.784 0 01-3.785-3.785v-6.055h-.001z"
				opacity="0.1"
			/>
			<path
				fill="#FDB797"
				d="M21.696 34.248h7.091a.24.24 0 01.24.24v5.815a3.785 3.785 0 01-3.785 3.785 3.784 3.784 0 01-3.785-3.785v-5.816a.24.24 0 01.239-.24z"
			/>
			<path fill="#000" d="M21.47 37.386c2.439.912 5.124.92 7.568.021v-.93H21.47v.91z" opacity="0.1" />
			<path
				fill="#FDB797"
				d="M25.268 37.893c5.992 0 10.849-4.857 10.849-10.849S31.26 16.195 25.268 16.195 14.42 21.052 14.42 27.045c0 5.99 4.857 10.848 10.85 10.848z"
			/>
			<path fill="#000" d="M17.54 17.176s4.573 9.28 17.47 3.891l-3.003-4.708-5.323-1.91-9.144 2.727z" opacity="0.1" />
			<path fill="#333" d="M17.54 17.04s4.573 9.281 17.47 3.89l-3.003-4.709-5.323-1.91-9.144 2.73z" />
			<path
				fill="#333"
				d="M17.5 16.411a6.267 6.267 0 011.554-2.526c2.134-2.11 5.633-2.555 7.427-4.96.43.667.097 1.694-.645 1.98 1.72-.011 3.712-.161 4.684-1.575a3.215 3.215 0 01-.543 3.395c1.524.072 3.152 1.103 3.248 2.625.066 1.015-.573 1.975-1.403 2.556-.83.582-1.842.849-2.834 1.068-2.897.64-13.378 3.316-11.488-2.563z"
			/>
			<g
				fill="#FDB797"
				d="M14.415 28.927c.557 0 1.01-.848 1.01-1.893s-.453-1.892-1.01-1.892c-.557 0-1.01.847-1.01 1.892s.453 1.893 1.01 1.893zM36.116 28.927c.557 0 1.009-.848 1.009-1.893s-.452-1.892-1.01-1.892c-.557 0-1.009.847-1.009 1.892s.452 1.893 1.01 1.893z"
			/>
		</g>
		<defs>
			<linearGradient
				id="paint0_linear_1103_23847"
				x1="25.456"
				x2="25.456"
				y1="50.365"
				y2="0.365"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="gray" stopOpacity="0.25" />
				<stop offset="0.54" stopColor="gray" stopOpacity="0.12" />
				<stop offset="1" stopColor="gray" stopOpacity="0.1" />
			</linearGradient>
			<clipPath id="clip0_1103_23847">
				<rect width="50" height="50" x="0.457" y="0.365" fill="#fff" rx="25" />
			</clipPath>
		</defs>
	</svg>
)

export default DefaultAvatar
